import React from "react";
import "./board.css";

const BoardBlack = props => {
	return (
		<div className="chessboard">
			<div className="capture">
				<img id="P10" alt="square" className="square" />
				<img id="P20" alt="square" className="square" />
				<img id="P30" alt="square" className="square" />
				<img id="P40" alt="square" className="square" />
				<img id="P50" alt="square" className="square" />
				<img id="P60" alt="square" className="square" />
				<img id="P70" alt="square" className="square" />
				<img id="P80" alt="square" className="square" />
				<img id="P19" alt="square" className="square" />
				<img id="P29" alt="square" className="square" />
				<img id="P39" alt="square" className="square" />
				<img id="P49" alt="square" className="square" />
				<img id="P59" alt="square" className="square" />
				<img id="P69" alt="square" className="square" />
				<img id="P79" alt="square" className="square" />
				<img id="P89" alt="square" className="square" />
			</div>

			<div className="board" onClick={props.BoardClicked}>
				<img id="P11" alt="square" className="square" />
				<img id="P21" alt="square" className="square" />
				<img id="P31" alt="square" className="square" />
				<img id="P41" alt="square" className="square" />
				<img id="P51" alt="square" className="square" />
				<img id="P61" alt="square" className="square" />
				<img id="P71" alt="square" className="square" />
				<img id="P81" alt="square" className="square" />

				<br />

				<img id="P12" alt="square" className="square" />
				<img id="P22" alt="square" className="square" />
				<img id="P32" alt="square" className="square" />
				<img id="P42" alt="square" className="square" />
				<img id="P52" alt="square" className="square" />
				<img id="P62" alt="square" className="square" />
				<img id="P72" alt="square" className="square" />
				<img id="P82" alt="square" className="square" />

				<br />

				<img id="P13" alt="square" className="square" />
				<img id="P23" alt="square" className="square" />
				<img id="P33" alt="square" className="square" />
				<img id="P43" alt="square" className="square" />
				<img id="P53" alt="square" className="square" />
				<img id="P63" alt="square" className="square" />
				<img id="P73" alt="square" className="square" />
				<img id="P83" alt="square" className="square" />

				<br />

				<img id="P14" alt="square" className="square" />
				<img id="P24" alt="square" className="square" />
				<img id="P34" alt="square" className="square" />
				<img id="P44" alt="square" className="square" />
				<img id="P54" alt="square" className="square" />
				<img id="P64" alt="square" className="square" />
				<img id="P74" alt="square" className="square" />
				<img id="P84" alt="square" className="square" />

				<br />

				<img id="P15" alt="square" className="square" />
				<img id="P25" alt="square" className="square" />
				<img id="P35" alt="square" className="square" />
				<img id="P45" alt="square" className="square" />
				<img id="P55" alt="square" className="square" />
				<img id="P65" alt="square" className="square" />
				<img id="P75" alt="square" className="square" />
				<img id="P85" alt="square" className="square" />

				<br />

				<img id="P16" alt="square" className="square" />
				<img id="P26" alt="square" className="square" />
				<img id="P36" alt="square" className="square" />
				<img id="P46" alt="square" className="square" />
				<img id="P56" alt="square" className="square" />
				<img id="P66" alt="square" className="square" />
				<img id="P76" alt="square" className="square" />
				<img id="P86" alt="square" className="square" />

				<br />

				<img id="P17" alt="square" className="square" />
				<img id="P27" alt="square" className="square" />
				<img id="P37" alt="square" className="square" />
				<img id="P47" alt="square" className="square" />
				<img id="P57" alt="square" className="square" />
				<img id="P67" alt="square" className="square" />
				<img id="P77" alt="square" className="square" />
				<img id="P87" alt="square" className="square" />

				<br />
				<img id="P18" alt="square" className="square" />
				<img id="P28" alt="square" className="square" />
				<img id="P38" alt="square" className="square" />
				<img id="P48" alt="square" className="square" />
				<img id="P58" alt="square" className="square" />
				<img id="P68" alt="square" className="square" />
				<img id="P78" alt="square" className="square" />
				<img id="P88" alt="square" className="square" />
			</div>

			<div className="capture">
				<img id="P01" alt="square" className="square" />
				<img id="P02" alt="square" className="square" />
				<img id="P03" alt="square" className="square" />
				<img id="P04" alt="square" className="square" />
				<img id="P05" alt="square" className="square" />
				<img id="P06" alt="square" className="square" />
				<img id="P07" alt="square" className="square" />
				<img id="P08" alt="square" className="square" />
				<img id="P91" alt="square" className="square" />
				<img id="P92" alt="square" className="square" />
				<img id="P93" alt="square" className="square" />
				<img id="P94" alt="square" className="square" />
				<img id="P95" alt="square" className="square" />
				<img id="P96" alt="square" className="square" />
				<img id="P97" alt="square" className="square" />
				<img id="P98" alt="square" className="square" />
			</div>
		</div>
	);
};

export default BoardBlack;
